module.exports = __webpack_public_path__ + "static/statesman_sec4-645b44fa3f8ecf3f04138f685b9ed20a.png";